import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HTTP_INTERCEPTORS, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { StorageService } from './storage.service';
import { EventBusService } from './event/event-bus.service';
import { EventData } from './event/event.class';
import { AuthService } from './auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(private storageService: StorageService, private eventBusService: EventBusService,
    private readonly authService: AuthService,
    private readonly snackBar:MatSnackBar) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.url.includes('/rest')) {
      const user = this.storageService.getUser();

      if (user.expires) {
        const timeout = user.expires.getTime() - Date.now()
        console.log('token expires in ', timeout)
        setTimeout(() => {
          console.warn('automatic log out')
          this.logout()
        }, timeout);
      }

      if (user.token) {
        console.log(req.url + ' headers before add Bearer', req.headers)
        req = req.clone({
          headers: req.headers.set("Authorization",
            "Bearer " + user.token)
        });
        console.log(req.url + ' headers after add Bearer', req.headers)
      } else {
        console.log(req.url + ' not logged')
        req = req.clone({
          withCredentials: true,
        });
      }
    }

    return next.handle(req).pipe(
      catchError((error) => {
        if (
          error instanceof HttpErrorResponse &&
          !req.url.includes('auth/signin') &&
          error.status === 401
        ) {
          return this.handle401Error(req, next);
        }

        return throwError(() => error);
      })
    );
  }

  private logout():void {
    
    this.snackBar.open('vous avez été automatiquement déconnecté, veuillez vous réidentifier ...', 'ok', {
      verticalPosition: 'bottom',
      panelClass: ['bg-red'],
    })
    this.authService.logout()
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;

      if (this.storageService.isLoggedIn()) {
        this.eventBusService.emit(new EventData('logout', null));
      }
    }

    return next.handle(request);
  }
}

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
];